/* eslint-disable prettier/prettier */
/* eslint-disable react/no-array-index-key */
import React, { useContext, useMemo } from "react";
import { arrayOf, bool, node, number, shape, string } from "prop-types";
import AssetsProvider from "../utils/AssetsProvider";
import { classes } from "../utils/classes";
import Image from "../Image";

export const sourceItemPropTypes = {
	src1x: string.isRequired,
	src2x: string,
	minWidth: number,
	maxWidth: number,
};

const SourceItem = ({ baseUrl = "", src1x, src2x, minWidth, maxWidth, ...props }) => {
	const media = useMemo(() => {
		if (minWidth && maxWidth) {
			return `(min-width: ${minWidth}px) and (max-width: ${maxWidth}px)`;
		}
		if (minWidth && !maxWidth) {
			return `(min-width: ${minWidth}px)`;
		}
		if (!minWidth && maxWidth) {
			return `(max-width: ${maxWidth}px)`;
		}
		return "";
	}, [minWidth, maxWidth]);

	const srcSet = useMemo(() => {
		if (src1x && src2x) {
			return `${baseUrl}${src1x} 1x, ${baseUrl}${src2x} 2x`;
		}
		if (src1x && !src2x) {
			return `${baseUrl}${src1x}`;
		}
		if (!src1x && src2x) {
			return `${baseUrl}${src2x}`;
		}
		return "";
	}, [src1x, src2x]);

	return <source media={`${media}`} srcSet={`${srcSet}`} {...props} />;
};

SourceItem.propTypes = {
	baseUrl: string,
	...sourceItemPropTypes,
};

const Picture = ({
	loading = "lazy",
	decoding = "async",
	isBaseUrl = true,
	className = "",
	src,
	alt = "",
	srcList = [],
	children = null,
	...props
}) => {
	const ctxBaseUrl = useContext(AssetsProvider.context);
	const baseUrl = isBaseUrl ? ctxBaseUrl : "";
	return (
		<picture className={classes("picture", className)}>
			{srcList.length
				? srcList.map((srcItem, index) => (
					<SourceItem key={`${srcItem.src1x}_${index}`} baseUrl={baseUrl} {...srcItem} />
				  ))
				: null}
			{children}
			<Image
				isBaseUrl={isBaseUrl}
				src={src}
				alt={alt}
				loading={loading}
				decoding={decoding}
				{...props}
			/>
		</picture>
	);
};

Picture.propTypes = {
	loading: string,
	decoding: string,
	isBaseUrl: bool,
	className: string,
	src: string.isRequired,
	alt: string,
	srcList: arrayOf(shape(sourceItemPropTypes)),
	children: node,
};

export default Picture;
